import dayjs = require('dayjs');
import utc = require('dayjs/plugin/utc');
import { nextOccurrence } from './datetime';
import { RepeatParsingResult } from './soonerorlater';

dayjs.extend(utc);

export function getDateKeyInTimezone(date: Date, timezoneOffsetMinutes?: number | null): string {
    if (!isTimezoneOffset(timezoneOffsetMinutes)) return dayjs(date).format('YYYY-MM-DD');
    return new Date(date.getTime() - timezoneOffsetMinutes * 60_000).toISOString().slice(0, 10);
}

export function getDateAtDateKeyInTimezone(dateKey: string, time: Date, timezoneOffsetMinutes?: number | null): Date {
    if (!isTimezoneOffset(timezoneOffsetMinutes)) {
        return dayjs(dateKey).hour(dayjs(time).hour()).minute(dayjs(time).minute()).second(dayjs(time).second()).toDate();
    }
    const [year, month, day] = dateKey.split('-').map(Number);
    const localTime = new Date(time.getTime() - timezoneOffsetMinutes * 60_000);
    return new Date(
        Date.UTC(year, month - 1, day, localTime.getUTCHours(), localTime.getUTCMinutes(), localTime.getUTCSeconds()) +
            timezoneOffsetMinutes * 60_000,
    );
}

export function getNextOccurrenceInTimezone(repeat: RepeatParsingResult, dueDate: Date, timezoneOffsetMinutes?: number | null): Date {
    if (!isTimezoneOffset(timezoneOffsetMinutes)) return nextOccurrence(repeat, dayjs(dueDate)).toDate();
    const localDueDate = dayjs.utc(new Date(dueDate.getTime() - timezoneOffsetMinutes * 60_000));
    return new Date(nextOccurrence(repeat, localDueDate).valueOf() + timezoneOffsetMinutes * 60_000);
}

export function isTimezoneOffset(value: number | null | undefined): value is number {
    return typeof value === 'number' && Number.isInteger(value) && value >= -840 && value <= 840;
}
